import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "dropdown-value" }
const _hoisted_2 = { class: "value-text" }
const _hoisted_3 = {
  key: 0,
  class: "dropdown-items"
}
const _hoisted_4 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _directive_click_outside = _resolveDirective("click-outside")!

  return _withDirectives((_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["filter-dropdown", { active: _ctx.active }]),
    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggle && _ctx.toggle(...args)))
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.activeValue), 1),
      _cache[1] || (_cache[1] = _createElementVNode("svg", {
        width: "11",
        height: "8",
        viewBox: "0 0 11 8",
        fill: "none",
        class: "value-caret"
      }, [
        _createElementVNode("path", {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d: "M9.50628 1.19378C9.84799 0.852073 10.402 0.852073 10.7437 1.19378C11.0854 1.53549 11.0854 2.08951 10.7437 2.43122L6.36872 6.80622C6.02701 7.14793 5.47299 7.14793 5.13128 6.80622L0.756282 2.43122C0.414573 2.08951 0.414573 1.53549 0.756282 1.19378C1.09799 0.852073 1.65201 0.852073 1.99372 1.19378L5.75 4.95006L9.50628 1.19378Z",
          fill: "currentColor"
        })
      ], -1))
    ]),
    (_ctx.active)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredItems, (item) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "dropdown-item",
              key: item.value,
              onClick: ($event: any) => (_ctx.select(item.value))
            }, _toDisplayString(item.label), 9, _hoisted_4))
          }), 128))
        ]))
      : _createCommentVNode("", true)
  ], 2)), [
    [_directive_click_outside, _ctx.close]
  ])
}